import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M22 21H7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 11 9 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Eraser";
const Eraser = memo(themed(Icon));
export {
  Eraser
};
//# sourceMappingURL=eraser.js.map
